module.exports = __webpack_public_path__ + "static/media/islamind_logo.43760051.png";